module.exports = __webpack_public_path__ + "static/media/vial.d86c108f.svg";